
export function getStudentGrade(gradeValue?: number): string {
  if (gradeValue === undefined) return '';
  if (gradeValue === 1) return 'K' ;
  else if (gradeValue === 14) return 'Other' ;
  else return `${gradeValue - 1}` ;
}

export function compareGrades(grade1: string, grade2: string) {
  return getNumericValueOfGrade(grade1) - getNumericValueOfGrade(grade2) ;
}

export function getNumericValueOfGrade(grade: string): number {
  if (grade === 'K') return 0 ;
  else if (grade === 'Other') return 100 ;
  else return Number(grade) ;
}
